import * as actionTypes from "./actionTypes";

const initialState = {
  error: null,
  loading: false,
  updating: false,
  deleting: false,
  images: [],
  status: null,
  serviceHistoryList: [],
  appointmentId: ""
};

const serviceHistoryStart = (state) => ({
  ...state,
  loading: true
});

const fetchServiceHistorySuccess = (state, action) => ({
  ...state,
  ...action.data,
  images: action.data.images ? action.data.images : [],
  error: null,
  loading: false
});

const serviceHistoryFail = (state, action) => ({
  ...state,
  error: action.error,
  loading: false
});

const updateServiceHistoryStart = (state) => ({
  ...state,
  updating: true
});

const updateServiceHistorySuccess = (state) => ({
  ...state,
  updating: false
});

const updateServiceHistoryFail = (state) => ({
  ...state,
  updating: false
});

const deleteServiceHistoryStart = (state) => ({
  ...state,
  deleting: true
});

const deleteServiceHistorySuccess = (state) => ({
  ...state,
  deleting: false
});

const deleteServiceHistoryFail = (state) => ({
  ...state,
  deleting: false
});

const updateServiceHistoryImagesStart = (state) => ({
  ...state,
  loading: true
});

const updateServiceHistoryImagesSuccess = (state) => ({
  ...state,
  loading: false
});

const updateServiceHistoryImagesFail = (state, action) => ({
  ...state,
  error: action.error,
  loading: false
});

const serviceHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SERVICE_HISTORY_START:
      return serviceHistoryStart(state);

    case actionTypes.FETCH_SERVICE_HISTORY_SUCCESS:
      return fetchServiceHistorySuccess(state, action);

    case actionTypes.FETCH_SERVICE_HISTORY_FAIL:
      return serviceHistoryFail(state, action);

    case actionTypes.UPDATE_SERVICE_HISTORY_START:
      return updateServiceHistoryStart(state);

    case actionTypes.UPDATE_SERVICE_HISTORY_SUCCESS:
      return updateServiceHistorySuccess(state);

    case actionTypes.UPDATE_SERVICE_HISTORY_FAIL:
      return updateServiceHistoryFail(state);

    case actionTypes.DELETE_SERVICE_HISTORY_START:
      return deleteServiceHistoryStart(state);

    case actionTypes.DELETE_SERVICE_HISTORY_SUCCESS:
      return deleteServiceHistorySuccess(state);

    case actionTypes.DELETE_SERVICE_HISTORY_FAIL:
      return deleteServiceHistoryFail(state);

    case actionTypes.UPDATE_SERVICE_HISTORY_IMAGES_START:
      return updateServiceHistoryImagesStart(state);

    case actionTypes.UPDATE_SERVICE_HISTORY_IMAGES_SUCCESS:
      return updateServiceHistoryImagesSuccess(state);

    case actionTypes.UPDATE_SERVICE_HISTORY_IMAGES_FAIL:
      return updateServiceHistoryImagesFail(state, action);

    default:
      return state;
  }
};

export default serviceHistoryReducer;
